import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Row, Col } from "react-bootstrap";
import { WMKLink } from "wmk-lib";
import styled from "styled-components";
import Theme from "../../../vars/ThemeOptions";

const Styled = {};
Styled.Links = styled(Row)`
  max-width: 800px;
  padding: 0 2vh 8vh 2vh;
  margin: auto;
`;

Styled.Link = styled(Col)`
  .wmk-link {
    color: ${Theme.hex("blue")};
    font-size: 1.72rem;
    border-bottom: 2px solid ${Theme.hex("concrete")};
    width: 100%;
    display: block;
    sup {
        color: ${Theme.hex("green")};
        top: 30%;
    }
  }
`;

const PerformanceHighlights = () => {
  const menus = useStaticQuery(query).menus.menuItems.map((item) => item);
  return (
    <Styled.Links className="flex-column">
      {menus.map((menuItem, i) => {
        const isAsset = menuItem.asset;
        return (
          <Styled.Link key={menuItem.title + i}>
            {isAsset ? (
              <WMKLink to={isAsset.file.url} target="_blank">
                {isAsset.title}
                <aside style={{ position: "absolute", top: 0, right: 0 }}>
                  <sup>DOWNLOAD</sup> <span>+</span>
                </aside>
              </WMKLink>
            ) : (
              <WMKLink to={"/" + menuItem.entry.slug} iv>
                {menuItem.title}{" "}
                <aside style={{ position: "absolute", top: 0, right: 0 }}>
                  <span>+</span>
                </aside>
              </WMKLink>
            )}
          </Styled.Link>
        );
      })}
    </Styled.Links>
  );
};

export default PerformanceHighlights;

const query = graphql`
  {
    menus: contentfulMenus(title: { eq: "Performance Highlights" }) {
      menuItems {
        ... on ContentfulLinks {
          ...NodeLinksFields
        }
        ... on ContentfulMenus {
          id
        }
      }
    }
  }
`;
